import Input from "../../Input"

const MoveRequest = ({ values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">درخواست موو و جوین</h6>
            <div className="font-sans">
                <Input
                    type="text"
                    label="رنک هایی که میتوانند از این قابلیت استفاده کنند*"
                    name="moveRequest-canUseList"
                    options={serverData?.sgList}
                    multi={true}
                    placeholder="مثال: 1,2,3"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.canUseList}
                />
            </div>
            <div className="mt-2">
                <label for="bot-name" class="block">
                    فرمت درخواست جوین *
                </label>
                <textarea
                    type="text"
                    name="moveRequest-joinMsg"
                    class="styled-input"
                    placeholder="format"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.joinMsg}
                />
            </div>
            <div className="mt-2">
                <label for="bot-name" class="block">
                    فرمت درخواست موو *
                </label>
                <textarea
                    type="text"
                    name="moveRequest-moveMsg"
                    class="styled-input"
                    placeholder="format"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.moveMsg}
                />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <div>این قابلیت به کاربرانی که اجازه اش را دارند درخواست موو یا جوین به چنل شما را بفرستن: </div>
                <br />
                <div className="flex justify-between">
                    <span>
                        شما میتوانید با کامند رو به رو درخواست بدهین که کاربر مورد نظر به چنل شما موو داده شود:{" "}
                    </span>
                    <span dir="ltr" className="text-green-300">
                        !move name
                    </span>
                </div>
                <div className="flex justify-between">
                    <span>شما میتوانید با کامند رو به رو درخواست جوین به چنل کاربر مورد نظر را بدهید: </span>
                    <span dir="ltr" className="text-green-300">
                        !join name
                    </span>
                </div>
                <div className="flex justify-between">
                    <span>اگر کسی درخواستی برای شما ارسال کرد میتوانید با کامند رو به رو قبول کنید: </span>
                    <span dir="ltr" className="text-green-300">
                        !accept
                    </span>
                </div>
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr">
                    <div>%sender: اسم درخواست دهنده</div>
                    <div>%receiver: اسم درخواست شونده</div>
                </div>
            </div>
        </div>
    )
}

export default MoveRequest
